export enum WorkspaceLimitsTypes {
  SEATS = 'SEATS',
  PROJECTS = 'PROJECTS',
  VIEWS = 'VIEWS',
  STORAGE = 'STORAGE',
}
